import { render, staticRenderFns } from "./AddMemberModal.vue?vue&type=template&id=458c1914"
import script from "./AddMemberModal.vue?vue&type=script&lang=ts"
export * from "./AddMemberModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports